// extracted by mini-css-extract-plugin
module.exports = {"locale_selector":"LocaleSelector_locale_selector__l7Dy7","locale_selector__icon":"LocaleSelector_locale_selector__icon___O7fc"};